interface AppEvent {
  name: string
  callbacks: any[]
}

let events: AppEvent[]

const initialize = () => {
  events = []
}

const registerEvent = eventName => {
  const event: AppEvent = { name: eventName, callbacks: [] }
  events[eventName] = event
}

const registerEventIfNeeded = eventName => {
  const event = events[eventName]
  if (!event) {
    registerEvent(eventName)
  }
}

const dispatchAppEvent = (eventName, eventArgs) => {
  registerEventIfNeeded(eventName)
  events[eventName].callbacks.forEach(callback => callback(eventArgs))
}

const addAppEventListener = (eventName, callback) => {
  registerEventIfNeeded(eventName)
  events[eventName].callbacks.push(callback)
}

export const EventSystem = {
  initialize,
  dispatchAppEvent,
  addAppEventListener,
}



// WEBPACK FOOTER //
// ./src/utils/services/eventSystem/eventSystem.ts